import { IsNotEmpty, IsOneOfThese } from '@core/services/csv/CSVCustomValidator'
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { CommissionData } from '../../api'
import { Expose } from 'class-transformer'
import { productTypes } from '@master/model/options/LineOfBusinessOptions'

export class IFASTTrailerTransactionCsvModel extends CSVModelInterface implements CommissionData {
  @Expose()
  @IsNotEmpty()
  private 'Selling Adviser' = 'CODE 123'

  get advCode () {
    return this['Selling Adviser']
  }

  @Expose()
  private 'Adviser Name' = 'Wen Adviser'

  get advName () {
    return this['Adviser Name']
  }

  private 'Account No' = ''

  get policyNumber () {
    return this['Account No']
  }

  @Expose()
  private 'Sedolnumber' = 'Sedolnumber'

  get componentCode () {
    return this.Sedolnumber
  }

  @Expose()
  private 'Fund Name' = 'Life Insurance Name'

  get productName () {
    return this['Fund Name']
  }

  @Expose()
  @IsNotEmpty()
  @IsOneOfThese(productTypes)
  private 'Product Type' = '[' + productTypes + ']'

  get productType () {
    return this['Product Type']
  }

  private 'Gross Investment Amount (AF)' = 0

  get premiumAmt () {
    return this['Gross Investment Amount (AF)']
  }

  private 'Indirect Comm (SGD)' = 0

  get commissionAmt () {
    return this['Indirect Comm (SGD)']
  }

  private 'Or Amt' = 0

  get orCommissionAmt () {
    return this['Or Amt']
  }

  @Expose()
  private 'Remuneration Type' = 'Overriding'

  get remark () {
    return this['Remuneration Type']
  }

  get clientName () {
    return ''
  }
}
